import React, { useState } from "react";

import { checkValidity } from "utils/fields";
import { updateObject } from "utils";
import { getPasswordChecks, isPasswordValid } from "utils/auth/password";

import Input from "components/Input";
import Button from "components/Button";
import PasswordRequirements from "features/Auth/PasswordRequirements";
import { Link } from "react-router-dom";

import classes from "./styles.module.scss";

const Step1 = ({ createUser, error, processing }) => {
    const [emailValid, setEmailValid] = useState(false);
    const [passwordCheck, setPasswordCheck] = useState(getPasswordChecks());
    const [regForm, setRegForm] = useState({
        email: {
            name: "email",
            value: "",
            type: "email",
            label: "Email Address",
            placeholder: "Your Email",
            valid: false,
            validation: {
                required: true,
                isEmail: true,
            },
            validMessage: "",
            touched: false,
        },
        password: {
            name: "password",
            value: "",
            type: "password",
            label: "Password",
            placeholder: "Your Password",
            valid: false,
            validation: {
                required: true,
            },
            validMessage: "",
            touched: false,
        },
        confirmPassword: {
            name: "confirmPassword",
            value: "",
            type: "password",
            label: "Confirm Password",
            placeholder: "Confirm Your Password",
            valid: false,
            validation: {
                required: true,
            },
            validMessage: "",
            touched: false,
        },
    });

    const onChangeHandler = (value, fieldName) => {
        const field = regForm[fieldName];
        const isPasswordField = fieldName === "password" || fieldName === "confirmPassword";

        let isValid = true;
        let message = "";

        if (!isPasswordField) {
            ({ isValid, message } = checkValidity(field.label, value, field.validation));
        }

        const updatedControls = updateObject(regForm, {
            [fieldName]: updateObject(field, {
                value,
                valid: isPasswordField ? true : isValid,
                validMessage: message,
                touched: true,
            }),
        });

        if (isPasswordField) {
            const nextChecks = getPasswordChecks(
                fieldName === "password" ? value : updatedControls.password.value,
                fieldName === "confirmPassword" ? value : updatedControls.confirmPassword.value
            );
            setPasswordCheck(nextChecks);
            updatedControls.password = updateObject(updatedControls.password, { valid: isPasswordValid(nextChecks) });
            updatedControls.confirmPassword = updateObject(updatedControls.confirmPassword, {
                valid: nextChecks.match,
            });
        }

        setEmailValid(updatedControls.email.valid);
        setRegForm(updatedControls);
    };

    const canContinue = emailValid && isPasswordValid(passwordCheck);

    return (
        <div className={classes.step1Wrapper}>
            <div className={classes.step1Header}>
                <h2>Create account</h2>
                <span>Use Volta SNAP to model homes, assess energy efficiency, and get detailed reports.</span>
                <span>Enter your email and password to get started. We&apos;ll ask for a few details next.</span>
            </div>
            <div className={classes.step1Form}>
                {Object.values(regForm).map(
                    ({ name, type, label, valid, validMessage, touched, placeholder, value }) => (
                        <Input
                            key={name}
                            large
                            name={name}
                            type={type}
                            label={label}
                            placeholder={placeholder}
                            hideLabel
                            invalid={!valid}
                            validMessage={validMessage}
                            touched={touched}
                            className={classes.input}
                            input={{
                                onChange: (value) => onChangeHandler(value, name),
                                value,
                            }}
                            isNewDesign={true}
                        />
                    )
                )}
                <PasswordRequirements passwordCheck={passwordCheck} />
            </div>
            <div className={classes.step1Footer}>
                <Button
                    disabled={!canContinue || processing}
                    type="submit"
                    onClick={async (event) => {
                        await createUser(event, regForm);
                    }}
                    style={{ width: "100%" }}
                >
                    {processing ? "Processing" : "Continue"}
                </Button>
                {error !== null && <p className={classes.error}>{error}</p>}
                <p>
                    Already have an account? <Link to="/login">Sign in</Link>
                </p>
            </div>
        </div>
    );
};

export default Step1;
